<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="panel panel-primary">
        <div class="panel-heading custom-panel">
          <div class="titulo-painel">
            <h2>{{ tituloDaEtapaAtual }}</h2>
          </div>
        </div>
      </div>

      <div>
        <div>
          <mat-divider fxFlex="1 0"></mat-divider>
        </div>
        <div
          *ngIf="usuarioLogado.username"
          class="text-danger"
          style="margin-top: 5px; margin-bottom: 5px"
        >
          Atendente Logado: {{ usuarioLogado.username }}
        </div>

        <div>
          <div class="form-group">
            <mat-divider fxFlex="1 0"></mat-divider>
          </div>
          <div class="panel-heading custom-sub-panel">
            <div class="titulo-sub-painel">
              <h3>Seleção do Exame</h3>
            </div>
          </div>

          <div class="form-container">
            <div class="form-column-1">
              <div class="table-container">
                <table class="table table-bordered table-striped table-proce">
                  <thead>
                    <tr>
                      <th class="col-check text-center">Selecionado</th>
                      <th>Procedimento</th>
                    </tr>
                  </thead>

                  <tbody>
                    <!-- Sem procedimentos -->
                    <tr *ngIf="listaDeProcedimento.length === 0">
                      <td colspan="2" class="text-center">
                        Nenhum procedimento disponível
                      </td>
                    </tr>

                    <!-- Lista de procedimentos -->
                    <tr
                      *ngFor="let exame of listaDeProcedimento"
                      (click)="onToggleExame(exame)"
                    >
                      <td class="col-check text-center">
                        <mat-checkbox
                          [checked]="isExameSelecionado(exame)"
                          (click)="$event.preventDefault()"
                          color="primary"
                        ></mat-checkbox>
                      </td>

                      <td>
                        {{ exame.nome }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            

            
          </div>

          <div class="form-row" style="margin-left: 10px; margin-right: 10px">
            <div
              class="form-group botao-marcacao-esquerda col-12 col-sm-6 col-md-6 col-lg-6"
            >
              <button
                type="button"
                (click)="telaAnterior()"
                mat-raised-button
                color="warn"
                matTooltip="Tela Anterior"
                style="margin-bottom: 10px"
                class="mat-button-marcacao"
              >
                <mat-icon>arrow_left</mat-icon>
                Tela Anterior
              </button>
            </div>
            <div
              class="form-group botao-marcacao-direita col-12 col-sm-6 col-md-6 col-lg-6"
            >
              <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="onSubmit()"
                matTooltip="Continuar Marcação"
                class="mat-button-marcacao"
              >
                Continuar Marcação
                <mat-icon>arrow_right</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
